import { JSEncrypt } from "jsencrypt";

export function encrypt(message: string) {
  const publicKey = (window as any).PK ;
  const RSAEncrypt = new JSEncrypt();

  RSAEncrypt.setPublicKey(publicKey);
  const encryptedMessage = RSAEncrypt.encrypt(message);

  return encryptedMessage;
}

const createTransactionID = (isCorrelationId = false) => {
  let currentDateTime = new Date()
      .toISOString()
      .replace(/-|:|T/gi, '')
      .replace('.', '')
      .slice(2)
      .slice(0, -1)
  return (
      'POR' + (isCorrelationId ? 'C' : '') + currentDateTime + '_' + Math.ceil(Math.random() * 100000)
  )
}
export { createTransactionID };
